import {isIEBrowser} from '@/utils'
import AhCa from "./ca/ahca";
import HnCa from "./ca/hnca";

var _CA;

//获取当前地区
function getAreaCode() {
    if (window.SITE_CONFIG.ca === 'AH'){
        return new AhCa()
    }
    if (window.SITE_CONFIG.ca === 'HN'){
        return new HnCa()
    }
}
//初始化CA
export function initCa(callback) {
    if (!isIEBrowser){
        callback && callback(false)
    }
    if(_CA === undefined){
        _CA = getAreaCode(window.SITE_CONFIG.ca)
        _CA.initOcxPlugin()
    }
    return _CA
}
//获取CA信息
export function getCaInfo(callback) {
    _CA.getCaKeyInfo(callback)
}

//获取CA数据签名
export function SignData(callback) {
   return _CA.getSignData(callback)
}
